const data = {
  id: 1,
  title: 'Listen and rearrange the words to make the correct sentence',
  subTitle: 'Nghe và sắp xếp lại các từ để tạo thành câu đúng',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/1dc6dbb1-b89a-41d5-82ba-8a5ea80e3e7b.mp3',
  imageUrl: '',
  question: 'The boys are playing football in the playground.',
  answer: 'The boys are playing football in the playground.',
  settings: {
    question: {
      shuffedType: 'word',
      // shuffedType: 'character',
    },
  },
};

export default data;
